(() => {
  const header = document.querySelector('[data-header]');

  // Expose header measurements so the hero and mobile drawer can sit around it.
  const measure = () => {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-height', `${Math.round(rect.height)}px`);
    document.documentElement.style.setProperty('--header-bottom', `${Math.round(rect.bottom)}px`);
  };

  // The transparent homepage header turns solid once the page scrolls.
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-solid', window.scrollY > 40);
    measure();
  };

  // Keep only one header panel (drawer or search) open at a time, close on Escape or outside click.
  const panels = document.querySelectorAll('[data-menu-drawer], [data-header-search]');
  panels.forEach((panel) => {
    panel.addEventListener('toggle', () => {
      if (!panel.open) return;
      measure();
      panels.forEach((other) => { if (other !== panel) other.open = false; });
      const input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') panels.forEach((panel) => { panel.open = false; });
  });
  document.addEventListener('click', (event) => {
    panels.forEach((panel) => { if (panel.open && !panel.contains(event.target)) panel.open = false; });
  });

  // Footer columns are accordions on phones and always open on larger screens.
  const footerQuery = window.matchMedia('(min-width: 750px)');
  const syncFooter = () => {
    document.querySelectorAll('[data-footer-accordion]').forEach((el) => { el.open = footerQuery.matches; });
  };
  footerQuery.addEventListener('change', syncFooter);

  syncFooter();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);
  document.addEventListener('shopify:section:load', () => { syncFooter(); measure(); });
})();
